/* JW Product — animations utilitaires : apparition au scroll, barre d'achat
   collante, léger parallaxe sur les collages. Aucune dépendance. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Apparition au scroll -------------------------------------------- */
  function initReveal(root) {
    var nodes = (root || document).querySelectorAll('[data-jwp-reveal]:not([data-jwp-seen])');
    if (!nodes.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.setAttribute('data-jwp-seen', ''); n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.12 }
    );
    nodes.forEach(function (n, i) {
      n.setAttribute('data-jwp-seen', '');
      if (!n.style.getPropertyValue('--jwp-i')) n.style.setProperty('--jwp-i', (i % 6).toString());
      io.observe(n);
    });
  }

  /* 2. Barre d'achat collante ------------------------------------------ */
  function initBar(scope) {
    var bar = scope.querySelector('[data-jwp-bar]');
    var sentinel = scope.querySelector('[data-jwp-sentinel]');
    if (!bar || !sentinel) return;

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) { bar.classList.toggle('is-in', !entries[0].isIntersecting); },
        { threshold: 0 }
      ).observe(sentinel);
    }

    var btn = bar.querySelector('[data-jwp-buy]');
    var submit = scope.querySelector('.product-form__submit');
    if (btn && submit) {
      btn.addEventListener('click', function () {
        var box = submit.getBoundingClientRect();
        var visible = box.top > 60 && box.bottom < window.innerHeight - 60;
        if (visible) {
          submit.click();
        } else {
          window.scrollTo({ top: window.pageYOffset + box.top - 140, behavior: reduce ? 'auto' : 'smooth' });
          submit.focus({ preventScroll: true });
        }
      });
    }

    /* Le prix de la barre suit la variante sélectionnée */
    var mirror = bar.querySelector('[data-jwp-bar-price]');
    var source = scope.querySelector('[data-jwp-price] .price__container');
    if (mirror && source && 'MutationObserver' in window) {
      var sync = function () {
        var live = source.querySelector('.price-item--sale, .price-item--regular');
        if (live) mirror.textContent = live.textContent.trim();
      };
      sync();
      new MutationObserver(sync).observe(source, { childList: true, subtree: true, characterData: true });
    }
  }

  /* 3. Parallaxe des collages ------------------------------------------ */
  function initParallax() {
    var items = Array.prototype.slice.call(document.querySelectorAll('[data-jwp-parallax]'));
    if (!items.length || reduce) return;
    var raf = null;
    function frame() {
      raf = null;
      var vh = window.innerHeight;
      items.forEach(function (el) {
        var box = el.getBoundingClientRect();
        if (box.bottom < -200 || box.top > vh + 200) return;
        var amount = parseFloat(el.getAttribute('data-jwp-parallax')) || 6;
        var progress = (box.top + box.height / 2 - vh / 2) / vh; // -1 … 1
        var img = el.querySelector('img');
        if (img) img.style.transform = 'scale(1.08) translate3d(0,' + (progress * amount).toFixed(2) + '%,0)';
      });
    }
    function onScroll() { if (!raf) raf = requestAnimationFrame(frame); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    frame();
  }

  function boot() {
    initReveal(document);
    document.querySelectorAll('[data-jwp-scope]').forEach(initBar);
    initParallax();
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  /* Éditeur de thème : re-câbler après rechargement d'une section */
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
    e.target.querySelectorAll('[data-jwp-scope]').forEach(initBar);
    initParallax();
  });

  window.JWProduct = { initReveal: initReveal };
})();

/* Géométrie interactive — <jw-geometry> (section-geometry-jw.liquid) */
if (!customElements.get('jw-geometry')) {
    customElements.define(
      'jw-geometry',
      class JwGeometry extends HTMLElement {
        connectedCallback() {
          this.rows = Array.from(this.querySelectorAll('.jwgeo__row'));
          this.dims = Array.from(this.querySelectorAll('.jwgeo__dim'));
          this.pinned = null;
          this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          this.rows.forEach((row) => {
            const i = Number(row.dataset.dim);
            row.addEventListener('mouseenter', () => this.show(i));
            row.addEventListener('focus', () => this.show(i));
            row.addEventListener('mouseleave', () => this.show(this.pinned));
            row.addEventListener('blur', () => this.show(this.pinned));
            row.addEventListener('click', () => {
              this.stopDemo();
              this.pinned = this.pinned === i ? null : i;
              this.rows.forEach((r) => r.setAttribute('aria-pressed', String(Number(r.dataset.dim) === this.pinned)));
              this.show(this.pinned);
            });
          });

          if (this.dataset.autoplay === 'true' && !this.reduce && 'IntersectionObserver' in window) {
            const io = new IntersectionObserver(
              (entries) => {
                if (!entries[0].isIntersecting) return;
                io.disconnect();
                this.demo();
              },
              { threshold: 0.35 }
            );
            io.observe(this);
            this.addEventListener('mouseenter', () => this.stopDemo(), { once: true });
          }
        }

        /* Une passe de démonstration : chaque cote s'allume 620 ms */
        demo() {
          let i = 0;
          const step = () => {
            if (this.demoStopped || i >= this.dims.length) {
              this.show(this.pinned);
              return;
            }
            this.show(i);
            i += 1;
            this.timer = setTimeout(step, 620);
          };
          this.timer = setTimeout(step, 320);
        }

        stopDemo() {
          this.demoStopped = true;
          if (this.timer) clearTimeout(this.timer);
        }

        show(i) {
          const idle = i === null || i === undefined || Number.isNaN(i);
          this.dataset.idle = String(idle);
          this.dims.forEach((g) => {
            const on = !idle && Number(g.dataset.dim) === i;
            g.toggleAttribute('data-active', on);
            const line = g.querySelector('.jwgeo__line');
            const m = on ? line.dataset.markerOn : line.dataset.markerOff;
            line.setAttribute('marker-start', m);
            line.setAttribute('marker-end', m);
          });
          this.rows.forEach((r) => r.setAttribute('aria-current', String(!idle && Number(r.dataset.dim) === i)));
        }
      }
    );
  }
